<template>
  <div>
    <v-row justify="start" justify-md="space-around" justify-lg="start">
      <v-col cols="12" sm="6">
        <LatePaymentsList :darkMode="$props.darkMode" class="mb-6"></LatePaymentsList>
        <RemindersList filter="active" class="mb-6"></RemindersList>
        <MaintenanceRequestsList filter="active"></MaintenanceRequestsList>


      </v-col>

      <v-col cols="12" sm="6">
        <PropertiesList class="mb-6"></PropertiesList>
      </v-col>

    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import PropertiesList from "@/components/Properties/PropertiesList"
import RemindersList from "@/components/Reminders/RemindersList";
import LatePaymentsList from "@/components/Dashboard/LatePaymentsList";
import MaintenanceRequestsList from "@/components/Maintenance/MaintenanceRequestsList";

export default {
  name: 'Dashboard',
  components: {
    PropertiesList,
    RemindersList,
    LatePaymentsList,
    MaintenanceRequestsList
  },
  props:{
    darkMode:{
      type:Boolean,
      default: false
    },
  },

  data: () => ({}),
}
</script>

<style lang="scss" scoped>

</style>